import React from 'react';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';

export default function CheckIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.7273 6.17149C19.0468 6.43509 19.0921 6.90779 18.8285 7.22731L10.5785 17.2273C10.4397 17.3957 10.2343 17.4952 10.0161 17.4998C9.79795 17.5045 9.58853 17.414 9.44254 17.2517L5.69254 13.0851C5.41544 12.7772 5.4404 12.303 5.74828 12.0259C6.05617 11.7488 6.53038 11.7737 6.80748 12.0816L9.9753 15.6014L17.6715 6.27273C17.9351 5.95322 18.4078 5.90789 18.7273 6.17149Z"
      />
    </SvgIcon>
  );
}
